import React from 'react';
import {
  Typography,
  Card,
  Row,
  Col,
  Form,
  Input,
  Button,
  Space,
  Divider,
} from 'antd';
import {
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;
const { TextArea } = Input;

const Contact: React.FC = () => {
  const onFinish = (values: any) => {
    console.log('Form values:', values);
    // Here you would typically send the form data to your backend
  };

  return (
    <div className='container mx-auto py-12 px-4'>
      <Title level={2} className='text-center mb-8'>
        Contact Us
      </Title>

      <Row gutter={[32, 32]}>
        <Col xs={24} lg={10}>
          <Card className='mb-8 h-full'>
            <Space direction='vertical' className='w-full' size='large'>
              <div>
                <Title level={4}>Get In Touch</Title>
                <Paragraph>
                  We're here to help! If you have any questions about our
                  products, delivery, or any other inquiries, please don't
                  hesitate to reach out to us using any of the methods below.
                </Paragraph>
              </div>

              <Divider />

              <Space direction='vertical' size='middle'>
                <Space align='start'>
                  <EnvironmentOutlined className='text-lg' />
                  <div>
                    <Text strong>Our Location</Text>
                    <Paragraph>
                      123 Fruit Street, Orchard District
                      <br />
                      Fresh City, FC 12345
                    </Paragraph>
                  </div>
                </Space>

                <Space align='start'>
                  <PhoneOutlined className='text-lg' />
                  <div>
                    <Text strong>Phone Number</Text>
                    <Paragraph>
                      Customer Service: (555) 123-4567
                      <br />
                      Orders & Deliveries: (555) 765-4321
                    </Paragraph>
                  </div>
                </Space>

                <Space align='start'>
                  <MailOutlined className='text-lg' />
                  <div>
                    <Text strong>Email</Text>
                    <Paragraph>
                      Customer Support: support@fruitshop.com
                      <br />
                      Orders: orders@fruitshop.com
                    </Paragraph>
                  </div>
                </Space>

                <Space align='start'>
                  <ClockCircleOutlined className='text-lg' />
                  <div>
                    <Text strong>Working Hours</Text>
                    <Paragraph>
                      Monday - Friday: 8:00 AM - 8:00 PM
                      <br />
                      Saturday - Sunday: 9:00 AM - 6:00 PM
                    </Paragraph>
                  </div>
                </Space>
              </Space>
            </Space>
          </Card>
        </Col>

        <Col xs={24} lg={14}>
          <Card title='Send Us a Message' className='mb-8'>
            <Form
              name='contact'
              layout='vertical'
              onFinish={onFinish}
              initialValues={{ remember: true }}
            >
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item
                    name='name'
                    label='Your Name'
                    rules={[
                      { required: true, message: 'Please enter your name' },
                    ]}
                  >
                    <Input placeholder='Enter your full name' />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    name='email'
                    label='Email Address'
                    rules={[
                      { required: true, message: 'Please enter your email' },
                      { type: 'email', message: 'Please enter a valid email' },
                    ]}
                  >
                    <Input placeholder='Enter your email address' />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item name='phone' label='Phone Number'>
                <Input placeholder='Enter your phone number (optional)' />
              </Form.Item>

              <Form.Item
                name='subject'
                label='Subject'
                rules={[{ required: true, message: 'Please enter a subject' }]}
              >
                <Input placeholder='What is your message about?' />
              </Form.Item>

              <Form.Item
                name='message'
                label='Message'
                rules={[
                  { required: true, message: 'Please enter your message' },
                ]}
              >
                <TextArea
                  rows={6}
                  placeholder='Please enter your message here...'
                />
              </Form.Item>

              <Form.Item>
                <Button type='primary' htmlType='submit' size='large'>
                  Send Message
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Contact;
